import React from 'react';
import classnames from 'classnames';
import DeviationGrid from '../DeviationGrid';
import ContainerSize from '../../../ContainerSize';
import { compose } from 'redux';
import { getDeviationEntityId } from '../../../redux/normalizr/schemas/deviation';
import SelectableDeviationWrapper from '../../_partials/SelectableDeviationWrapper';
import DeviationDumbView from '../../../DeviationViews/Dumbo';
import withFilter from '../../_hocs/withFilter';
import PollForThumbReady from '../../../DeviationViews/Helper/PollForThumbReady';
import { getDeviationResourceType, getDeviationType, getPrimaryTier, isDeviationAuthor, isFileLargerThanSizeOrEqual, isFileSizeBetween, } from '../../../DeviationViews/_helpers';
import { getIsGif } from '../../../redux/deviations/selectors';
import MediaService from '../../../utils/DeviationMediaService';
import { useCurrentUser } from '../../../utils/hooks/useCurrentUser';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { DeviationTypes } from '../../../types/deviation';
import deviationSelectorStyles from './DeviationSelector.scss';
var enhance = compose(withFilter);
var DeviationSelector = function (_a) {
    var deviations = _a.deviations, allowedDeviationTypes = _a.allowedDeviationTypes, allowedDeviationResourceTypes = _a.allowedDeviationResourceTypes, allowGifs = _a.allowGifs, allowPremium = _a.allowPremium, allowInTierContent = _a.allowInTierContent, allowMature = _a.allowMature, minDeviationWidth = _a.minDeviationWidth, minDeviationHeight = _a.minDeviationHeight, minFileSize = _a.minFileSize, maxFileSize = _a.maxFileSize, _b = _a.ignoreDeviationIds, ignoreDeviationIds = _b === void 0 ? [] : _b;
    var currentUser = useCurrentUser();
    var deviationRenderer = function (deviation) {
        var isInTier = !!getPrimaryTier(deviation);
        var isOwner = isDeviationAuthor(deviation, currentUser);
        var isSelectionAllowed = !ignoreDeviationIds.includes(deviation.deviationId);
        var isGif = getIsGif(deviation);
        var isPremium = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData).isPremium;
        var deviationType = getDeviationType(deviation);
        if ((!allowPremium && isPremium) ||
            (!allowMature && deviation.isMature) ||
            (!allowInTierContent && isInTier) ||
            (isInTier && !isOwner) ||
            (!allowGifs && isGif) ||
            (allowedDeviationTypes &&
                !allowedDeviationTypes.includes(deviationType)) ||
            (allowedDeviationResourceTypes &&
                !allowedDeviationResourceTypes.includes(getDeviationResourceType(deviation)))) {
            isSelectionAllowed = false;
        }
        if (minDeviationWidth || minDeviationHeight) {
            isSelectionAllowed =
                isSelectionAllowed &&
                    isFileLargerThanSizeOrEqual(MediaService.getLargestFullview(deviation), minDeviationWidth, minDeviationHeight);
        }
        if (minFileSize !== undefined || maxFileSize !== undefined) {
            isSelectionAllowed =
                isSelectionAllowed &&
                    isFileSizeBetween(MediaService.getLargestFullview(deviation), minFileSize, maxFileSize);
        }
        var isStatus = deviationType === DeviationTypes.STATUS;
        return (React.createElement(ContainerSize, { className: deviationSelectorStyles['thumb-measured-container'] }, function (_a) {
            var width = _a.width, height = _a.height;
            return (React.createElement(SelectableDeviationWrapper, { key: getDeviationEntityId(deviation), deviation: deviation, isDisabled: !isSelectionAllowed },
                React.createElement(PollForThumbReady, { deviation: deviation },
                    React.createElement(DeviationDumbView, { className: classnames(isStatus && deviationSelectorStyles['status-thumb']), deviation: deviation, width: width, height: height }))));
        }));
    };
    return (React.createElement(DeviationGrid, { deviations: deviations, deviationRenderer: deviationRenderer }));
};
DeviationSelector.displayName = 'DeviationSelector.connected';
export default enhance(DeviationSelector);
//# sourceMappingURL=DeviationSelector.connected.js.map